import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { managePodcastsPageQuery, managePodcastsPageQueryVariables } from "../__generated__/managePodcastsPageQuery";

const MANAGE_PODCASTS_QUERY = gql`
  query managePodcastsPageQuery($input: GetPodcastsInput!) {
    getPodcastsForHost(input: $input) {
      ok
      error
      totalPages
      totalResults
      podcasts {
        id
        title
        updatedAt
        category {
          name
        }
        episodes {
          id
        }
      }
    }
  }
`;

export const ManagePodcasts = () => {
  const [page, setPage] = useState(1);
  const { data } = useQuery<managePodcastsPageQuery, managePodcastsPageQueryVariables>(MANAGE_PODCASTS_QUERY, {
    variables: {
      input: {
        page,
      },
    },
  });
  const onNextPageClick = () => setPage((current) => current + 1);
  const onPrevPageClick = () => setPage((current) => current - 1);

  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Manage | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center items-center text-center pt-10">
        <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
          <div className="relative mb-3 mr-auto">
            <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Manage Podcasts</div>
          </div>
          {data?.getPodcastsForHost.podcasts?.map((podcast) => (
            <Link
              key={podcast.id}
              to={`/manage-podcast/${podcast.id}`}
              className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start hover:bg-gray-800"
            >
              <div className="flex flex-col items-start">
                <div className="py-1 px-2 mb-2 bg-pink-800 rounded-lg text-md">{podcast.category?.name}</div>
                <div className=" font-bold text-xl text-center tracking-wider mb-2">{podcast.title}</div>
                <div className="font-semibold text-md text-gray-200 mb-2">
                  Total Episodes: {podcast.episodes ? podcast.episodes.length : 0}
                </div>
                <div className=" font-semibold text-sm text-gray-300">Last updated: {podcast.updatedAt}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-3 text-center max-w-md items-center mx-auto mt-10">
        {page > 1 ? (
          <button onClick={onPrevPageClick} className="focus:outline-none font-medium text-2xl">
            &larr;
          </button>
        ) : (
          <div></div>
        )}
        <span>
          Page {page} of {data?.getPodcastsForHost.totalPages}
        </span>
        {page !== data?.getPodcastsForHost.totalPages ? (
          <button onClick={onNextPageClick} className="focus:outline-none font-medium text-2xl">
            &rarr;
          </button>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};
